import React, { useState, useEffect } from 'react'
import VotesList from '../VotesList'
import VoteDetails from '../VoteDetails'
import EditVote from '../EditVote'
import VotesError from '../VotesError'
import componentStyles from './VotesView.module.scss'
import { Vote, VotesViewProps, VotesMode, VotesErrorType, VoteStatus, WebcastStatusForVotes } from './../types'
import VotesResultsView from '../VotesResultsView/VotesResultsView'

const Votes: React.FC<VotesViewProps> = ({
    votes,
    createVote,
    deleteVote,
    editVote,
    endVote,
    endAllVotes,
    startVote,
    setMode,
    mode,
    selectedVoteId,
    webcastStatus,
    countdownStart,
    clearCountdown
}) => {

  const emptyVote: Vote = {
    question: '',
    options: []
  }

  const [ selectedVote, setSelectedVote ] = useState(emptyVote)
  const [ previousWebcastStatus, setPreviousWebcastStatus ] = useState<string | undefined>()

  const voteUpdated = () =>
    selectedVote.lastUpdated !== votes.find( vote => vote.id === selectedVoteId )?.lastUpdated

  useEffect(() => {

    if (selectedVoteId !== selectedVote.id || voteUpdated){

      setSelectedVote (votes.find(val => val.id === selectedVoteId) ?? emptyVote )
    }
  }, [selectedVoteId, votes])

  if(webcastStatus === WebcastStatusForVotes.COMPLETE
    && previousWebcastStatus !== WebcastStatusForVotes.COMPLETE ){

    endAllVotes()
    setPreviousWebcastStatus( webcastStatus )
  }



  let viewComponent

  switch(mode){
    case VotesMode.DETAILS:
      // @ts-ignore
      viewComponent = <VoteDetails
        webcastStatus={webcastStatus}
        {...selectedVote}
        editVote={editVote}
        deleteVote={deleteVote}
        startVote={startVote}
        setMode={setMode}
        openVoteId={votes.find(vote=> vote.status === VoteStatus.open)?.id}
      />
      break
    case VotesMode.EDIT:
      viewComponent = <EditVote
        {...selectedVote}
        setMode={setMode}
        createVote={createVote}
        editVote={editVote}
      />
      break
    case VotesMode.ERROR:
      viewComponent = <VotesError
        error={VotesErrorType.SERVER_ERROR}
        confirmHandler={() => setMode({ mode: VotesMode.LIST })}
      />
      break
    case VotesMode.RESULTS:
      // @ts-ignore
      viewComponent = <VotesResultsView
        {...selectedVote }
        setMode={setMode}
        countdownStart={countdownStart}
        clearCountdown={clearCountdown}
        endVote={endVote}
      />
      break
    case VotesMode.LIST:
    default:
      const viewProps = { votes, setMode, webcastStatus }
      viewComponent = <VotesList {...viewProps} />
  }

  return (
    <div
      className={componentStyles['polls-view-container']}
      data-bdd="polls-view-container"
    >
      { viewComponent }
    </div>
  )

}

export default Votes
